import * as React from 'react';
import { Typography, TypographyProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  label: {
    display: 'block',
    marginBottom: 5,
    marginTop: 16,
    fontFamily: 'Montserrat',
    fontSize: '0.875rem',
    fontWeight: 600,
    letterSpacing: '-0.00875rem',
    color: '#000000'
  }
}));

type Props = TypographyProps & { htmlFor?: string };

const CustomFormLabel: React.FC<Props> = ({ className, ...props }) => {
  const classes = useStyles();
  return (
    <Typography
      component="label"
      className={[classes.label, className].filter(Boolean).join(' ')}
      {...props}
    />
  );
};

export default CustomFormLabel;
